import React, { useState, useEffect } from 'react';
import AdminSidebar from '../../components/AdminSidebar';
import AdminHeader from '../../components/AdminHeader';
import './ContactMessagesPage.css';

// Données fictives pour la démonstration
const demoMessages = [
  {
    id: 1,
    name: "Jean Dupont",
    email: "jean.dupont@email.com",
    subject: "Question sur la livraison",
    message: "Bonjour, j'aimerais savoir quel est le délai de livraison moyen pour les commandes passées le week-end ? Merci d'avance pour votre réponse.",
    date: "2025-04-14T09:45:00",
    status: "Non lu"
  },
  {
    id: 2,
    name: "Marie Leroy",
    email: "marie.leroy@email.com",
    subject: "Problème avec ma commande",
    message: "Bonjour, j'ai passé une commande hier (ref: ORD5612) mais je n'ai toujours pas reçu de confirmation par email. Pouvez-vous vérifier si ma commande a bien été enregistrée ? Merci.",
    date: "2025-04-13T18:30:00",
    status: "Non lu"
  },
  {
    id: 3,
    name: "Thomas Martin",
    email: "thomas.martin@email.com",
    subject: "Demande de partenariat",
    message: "Bonjour, je suis le propriétaire du restaurant 'La Bonne Fourchette' à Lyon. J'aimerais savoir comment rejoindre votre plateforme de livraison. Pourriez-vous m'envoyer les informations concernant les conditions de partenariat ? Merci beaucoup.",
    date: "2025-04-13T14:20:00",
    status: "Lu"
  },
  {
    id: 4,
    name: "Sophie Dubois",
    email: "sophie.dubois@email.com",
    subject: "Suggestion d'amélioration",
    message: "Bonjour, j'utilise régulièrement votre service et j'apprécie beaucoup la qualité des restaurants proposés. J'aurais une suggestion d'amélioration : il serait pratique de pouvoir noter nos plats préférés pour les retrouver facilement lors des prochaines commandes. Merci pour votre service !",
    date: "2025-04-12T11:15:00",
    status: "Lu"
  },
  {
    id: 5,
    name: "Luc Bernard",
    email: "luc.bernard@email.com",
    subject: "Remboursement commande",
    message: "Bonjour, j'ai passé une commande hier soir (ref: ORD5598) mais celle-ci n'est jamais arrivée. J'ai essayé de contacter le service client mais sans succès. Je souhaiterais être remboursé pour cette commande. Merci de me contacter rapidement.",
    date: "2025-04-11T20:05:00",
    status: "Répondu"
  }
];

const ContactMessagesPage = () => {
  const [messages, setMessages] = useState(demoMessages);
  const [filteredMessages, setFilteredMessages] = useState(demoMessages);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [showMessageDetails, setShowMessageDetails] = useState(false);
  const [replyText, setReplyText] = useState('');
  
  // Simuler un chargement de données depuis une API
  useEffect(() => {
    // Dans un cas réel, vous feriez un appel API ici
    // fetch('/api/admin/contact-messages')
    //   .then(response => response.json())
    //   .then(data => {
    //     setMessages(data);
    //     setFilteredMessages(data);
    //   });
  }, []);
  
  // Filtrer les messages selon les critères
  useEffect(() => {
    let result = messages;
    
    // Filtrage par terme de recherche
    if (searchTerm) {
      result = result.filter(message => 
        message.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        message.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
        message.subject.toLowerCase().includes(searchTerm.toLowerCase()) ||
        message.message.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    // Filtrage par statut
    if (statusFilter !== 'all') {
      result = result.filter(message => message.status === statusFilter);
    }
    
    setFilteredMessages(result);
  }, [messages, searchTerm, statusFilter]);
  
  const handleViewMessage = (message) => {
    // Marquer le message comme lu
    if (message.status === "Non lu") {
      const updatedMessages = messages.map(msg => {
        if (msg.id === message.id) {
          return { ...msg, status: "Lu" };
        }
        return msg;
      });
      setMessages(updatedMessages);
    }
    
    setSelectedMessage(message);
    setShowMessageDetails(true);
  };
  
  const handleSendReply = () => {
    if (!replyText.trim()) {
      alert("Veuillez écrire une réponse avant d'envoyer.");
      return;
    }
    
    // Dans un cas réel, vous enverriez la réponse via une API
    // fetch('/api/admin/contact-messages/reply', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify({
    //     messageId: selectedMessage.id,
    //     replyText: replyText
    //   }),
    // }).then(response => response.json())
    //   .then(data => { ... })
    
    // Pour la démo, on simule l'envoi
    const updatedMessages = messages.map(msg => {
      if (msg.id === selectedMessage.id) {
        return { ...msg, status: "Répondu" };
      }
      return msg;
    });
    
    setMessages(updatedMessages);
    setSelectedMessage({ ...selectedMessage, status: "Répondu" });
    setReplyText('');
    
    alert("Réponse envoyée avec succès !");
  };
  
  const handleDeleteMessage = (messageId) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer ce message ?")) {
      // Dans un cas réel, vous supprimeriez via une API
      // fetch(`/api/admin/contact-messages/${messageId}`, {
      //   method: 'DELETE'
      // }).then(response => {
      //   if (response.ok) { ... }
      // })
      
      // Pour la démo, on filtre simplement le message
      const updatedMessages = messages.filter(msg => msg.id !== messageId);
      setMessages(updatedMessages);
      
      if (selectedMessage && selectedMessage.id === messageId) {
        setShowMessageDetails(false);
        setSelectedMessage(null);
      }
    }
  };
  
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  
  const getStatusClass = (status) => {
    switch (status) {
      case "Non lu":
        return "status-unread";
      case "Lu":
        return "status-read";
      case "Répondu":
        return "status-replied";
      default:
        return "";
    }
  };
  
  const closeModal = () => {
    setShowMessageDetails(false);
    setSelectedMessage(null);
    setReplyText('');
  };
  
  return (
    <div className="admin-dashboard">
      <AdminSidebar />
      <div className="dashboard-content">
        <AdminHeader title="Messages de contact" />
        
        <div className="contact-messages-container">
          <div className="filters-bar">
            <div className="search-box">
              <input 
                type="text" 
                placeholder="Rechercher par nom, email, sujet ou contenu..." 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button className="search-button">Rechercher</button>
            </div>
            
            <div className="filter-options">
              <div className="filter-group">
                <label>Statut:</label>
                <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                  <option value="all">Tous les messages</option>
                  <option value="Non lu">Non lus</option>
                  <option value="Lu">Lus</option>
                  <option value="Répondu">Répondus</option>
                </select>
              </div>
            </div>
          </div>
          
          <div className="messages-list-container">
            <table className="messages-table">
              <thead>
                <tr>
                  <th>Statut</th>
                  <th>Date</th>
                  <th>Nom</th>
                  <th>Email</th>
                  <th>Sujet</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredMessages.map(message => (
                  <tr key={message.id} className={message.status === "Non lu" ? "unread-row" : ""}>
                    <td>
                      <span className={`status-badge ${getStatusClass(message.status)}`}>
                        {message.status}
                      </span>
                    </td>
                    <td>{formatDate(message.date)}</td>
                    <td>{message.name}</td>
                    <td>{message.email}</td>
                    <td>{message.subject}</td>
                    <td className="actions-cell">
                      <button 
                        className="action-button view-button" 
                        onClick={() => handleViewMessage(message)}
                      >
                        Voir
                      </button>
                      <button 
                        className="action-button delete-button" 
                        onClick={() => handleDeleteMessage(message.id)}
                      >
                        Supprimer
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {filteredMessages.length === 0 && (
              <div className="no-messages">
                Aucun message ne correspond aux critères de recherche.
              </div>
            )}
          </div>
          
          {/* Modal pour les détails du message */}
          {showMessageDetails && selectedMessage && (
            <div className="modal-backdrop">
              <div className="message-details-modal">
                <button className="close-modal" onClick={closeModal}>×</button>
                <div className="message-header">
                  <h2>{selectedMessage.subject}</h2>
                  <div className="message-info">
                    <div className="info-row">
                      <span className="info-label">De:</span>
                      <span className="info-value">{selectedMessage.name} ({selectedMessage.email})</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">Date:</span>
                      <span className="info-value">{formatDate(selectedMessage.date)}</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">Statut:</span>
                      <span className={`info-value status-badge ${getStatusClass(selectedMessage.status)}`}>
                        {selectedMessage.status}
                      </span>
                    </div>
                  </div>
                </div>
                
                <div className="message-body">
                  <h3>Message</h3>
                  <div className="message-content">
                    {selectedMessage.message}
                  </div>
                </div>
                
                <div className="reply-section">
                  <h3>Répondre</h3>
                  <textarea 
                    className="reply-textarea" 
                    placeholder="Écrire une réponse..." 
                    value={replyText}
                    onChange={(e) => setReplyText(e.target.value)}
                  ></textarea>
                  <div className="reply-actions">
                    <button className="cancel-btn" onClick={closeModal}>
                      Fermer
                    </button>
                    <button className="reply-btn" onClick={handleSendReply}>
                      Envoyer la réponse
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactMessagesPage;
/*code 2 de kimi


*/